<template>
  <div>Login Successful, redirecting...</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	methods: {
		...mapActions("authStore", ["oidcSignInCallback"])
	},
	created() {
		this.oidcSignInCallback()
			.then(redirectPath => {
				this.$router.push("/");
			})
			.catch(err => {
				this.$router.push("/"); // Handle errors any way you want
			});
	}
};
</script>
